import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InputsReducer, UpdateInputPayload } from './inputs';
import { Input, Inputs } from 'src/lib/constants';

type QuickEditReducer = {
  isVisible: boolean;
  inputs: InputsReducer;
  loading: boolean;
  questions: Input[];
};

const initialState: QuickEditReducer = {
  isVisible: false,
  inputs: {},
  loading: false,
  questions: [],
};

const quickEditReducer = createSlice({
  name: 'quickEdit',
  initialState,
  reducers: {
    showQuickEdit(state) {
      state.isVisible = true;
    },
    hideQuickEdit(state) {
      state.isVisible = false;
    },
    updateInput(state, action: PayloadAction<UpdateInputPayload>) {
      const { name, value } = action.payload;
      if (Inputs[name]) {
        // @ts-expect-error
        state.inputs[name] = value;
      }
    },
    updateInputs(state, action: PayloadAction<InputsReducer>) {
      state.inputs = {
        ...action.payload,
      };
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setQuestions(state, action: PayloadAction<Input[]>) {
      state.questions = action.payload;
    },
  },
});

export const {
  hideQuickEdit,
  setLoading,
  setQuestions,
  showQuickEdit,
  updateInput,
  updateInputs,
} = quickEditReducer.actions;
export default quickEditReducer.reducer;
